import { render, staticRenderFns } from "./PasswordInputs.vue?vue&type=template&id=064a8e4f&"
import script from "./PasswordInputs.vue?vue&type=script&lang=js&"
export * from "./PasswordInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports